export function ProgressBar({ pct = 0, height = "h-2.5", segments }) {
  const clamped = Math.min(Math.max(pct, 0), 100);
  return (
    <div className={`w-full overflow-hidden rounded-full bg-slate-100 ${height}`}>
      {segments ? (
        <div className="flex h-full w-full">
          {segments.map((s, i) => (
            <div key={i} className="h-full transition-all duration-500" style={{ width: `${Math.min(s.pct, 100)}%`, backgroundColor: s.color }} title={s.label} />
          ))}
        </div>
      ) : (
        <div className="h-full rounded-full transition-all duration-500" style={{ width: `${clamped}%`, background: "linear-gradient(90deg,#0057A8,#0284C7)" }} />
      )}
    </div>
  );
}
